<div>
  <mat-icon>{{ icon() }}</mat-icon>
  <span value>{{ label() }}</span>
</div>
